import { Search } from 'lucide-react';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { urls } from '@/lib/urls';
import { cn } from '@/lib/utils';

/** Searches on Enter: codes, titles, cast and genres, in any language, typos forgiven. */
export function SearchBox(props: { readonly className?: string }) {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [value, setValue] = useState(params.get('q') ?? '');

  return (
    <form
      role="search"
      className={cn('relative', props.className)}
      onSubmit={(event) => {
        event.preventDefault();
        const q = value.trim();
        if (q.length > 0) {
          navigate(urls.search(q));
        }
      }}
    >
      <Search className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
      <input
        type="search"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder="Search codes, titles, cast…"
        aria-label="Search"
        className="h-9 w-full rounded-full border border-input bg-muted/40 pl-8 pr-3 text-sm placeholder:text-muted-foreground focus-visible:border-ring focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
      />
    </form>
  );
}
